"use client";
import { useResponsive } from "@/client/hooks/useResponsive";
import { renderToString } from "react-dom/server";
import { documentToReactComponents } from "@contentful/rich-text-react-renderer";
// import { Card } from "../Card/Card";
import { ImageType } from "@/types/app.type";
import classNames from "classnames";
import { ReactElement } from "react";
import dynamic from "next/dynamic";
import Spinner from "@/components/Spinner";


const Card = dynamic(() => import('@/blocks/Cards/Card/Card'), {
	ssr: false, // optional: disable SSR if the component depends on `window`
	loading: () => <Spinner loading={true}><></></Spinner>,
});
export interface VideoCardProps {
	"data-test-id"?: string;
	/**
	 * The VideoCard className.
	 * @type {string}
	 */
	className?: string;
	/**
	 * The description of the VideoCard.
	 * @type string
	 * @required
	 */
	description: string;
	/**
	 * Hide Card text 
	 * @type string
	 * @required
	 */
	hideText?: boolean;
	/**
	 * The image source of the VideoCard.
	 * @type ImageType
	 * @required
	 */
	image: ImageType;
	/**
	 * The description of the VideoCard.
	 * @type string
	 * @optional
	 */
	author?: string;
	/**
	 * The description of the VideoCard.
	 * @type string
	 * @optional
	 */
	jobPosition?: string;
	/**
	 * Card Subtitle Font Size.
	 * @type string
	 * @optional
	 */
	subtitleFontSize?: 's' | 'm' | 'l' | 'xl';
	/**
	 * Card Title Font Size.
	 * @type string
	 * @optional
	 */	
	titleFontSize?: 's' | 'm' | 'l' | 'xl';
	/**
	 * Card Body Font Size.
	 * @type string
	 * @optional
	 */	
	bodyFontSize?: 'xxs' | 'xs' | 's' | 'm' | 'l' | 'xl';
	/**
	 * Button 1 Label of the Card.
	 * @type string
	 * @optional
	*/
	btn1_label?: string;
	/**
	 * Button 1 Icon in the Card.
	 * @type any
	 * @optional
	*/
	btn1_icon?: any;
	/**
	 * Button 1 Icon Position
	 * @type string
	 * @optional
	*/
	btn1_iconPosition?: 'hide' | 'top' | 'right' | 'left';
	/**
	 * Button 1 Variant.
	 * @type string
	 * @optional
	 */
	btn1_variant?: string;
	/**
	 * Button 1 size.
	 * @type string
	 * @optional
	 */
	btn1_size?: string;
	/**
	 * The action of the Card.
	 * @type () => void
	 * @optional
	*/
	btn1_action?: () => void;
	/**
	 * Enable animation triggered whe the element is visible.
	 * @type boolean
	 * @optional
	 */
	animated?: boolean;
	/**
	 * The animation type triggered whe the element is visible. Default is fadeIn
	 * @type string
	 * @optional
	*/
	hideButton: boolean;
	animation: string;
	buttonUrl: string;
	linkTargetBlank: boolean;
	centerTextVertically: boolean;
	roundedCorners: boolean;
	// Media:
	videoPosition: "Normal" | "LeftEdge";
	cardBackgroundColor?: string;
	secondaryBackground?: boolean;
	videoWidth?: string; //number;
	videoHeight?: string; //number;
	videoWrapperWidth?: string;
	videoWrapperHeight?: string;
	videoStartViewX?: string;
	videoStartViewY?: string;
	eventName?: string;
	playButtonPosition: 'none' | 'center' | 'bottom-left' | 'top-right';
	pauseable: boolean;
	autoPlay: boolean;
	mediaOverlay?: ReactElement;
	horizontalAlignment?: string;
    verticalAlignment?: string;
	mobileVideo?: any;
	thumbnailOnly?: boolean;
	contentMinHeight?: string;
	contentMaxHeight?: string;

	// Makeshift Implementation----------------------------------
	// mobileVideoWidth?: string;
	// mobileVideoHeight?: string;
	// mobileVideoWrapperWidth?: string;
	// mobileVideoWrapperHeight?: string;
}



// export function VideoCard(props: VideoCardProps) {
export function VideoCard({
	// Text:
	title,
	subtitle,
	description,
	hideText = false,
	centerTextVertically = false,
	// Font
	subtitleFontSize = "s",
	titleFontSize = "m",
	bodyFontSize = "l",
	// Button:
	hideButton = false,
	btn1_label = "Show details",
	btn1_icon = 'Placeholder',
	btn1_iconPosition = "after",
	btn1_variant = "", //"ghost",
	btn1_size = "s",
	btn1_action = () => {},
	buttonUrl,
	linkTargetBlank = false,
	// Media:
	image,
	video,
	mobileVideo,
	videoPosition = "Normal",
	videoWidth = "100px",
	videoHeight = "auto",
	videoWrapperWidth = '',
	videoWrapperHeight = '',
	cardBackgroundColor = "#FFFFFF",
	videoStartViewX = '0px',
	videoStartViewY = '0px',
	playButtonPosition,
	pauseable,
	autoPlay,
	// Others:
	animated,
	animationType,
	roundedCorners,
	eventName,
	maxWidth,
	mediaOverlay,
	horizontalAlignment,
	verticalAlignment,
	thumbnailOnly = false,
	contentMinHeight = "",
	contentMaxHeight = "auto",



	//------------- Makeshift New Implementation (DELETE) ---------------
	// mobileVideoWidth = "120px",
	// mobileVideoHeight = "auto",
	// mobileVideoWrapperWidth = '',
	// mobileVideoWrapperHeight = '',
	//------------- Makeshift New Implementation (DELETE) ---------------




}: any) {
	const { isMd, isSm } = useResponsive();

	const width = isMd ? 370 : 350;
	const height = isMd ? 210 : 200;

	const placeholderImage = {
		width: width, // TODO: get number value from user to pass it later into NextJS Image component
		height: height, // TODO: get number value from user to pass it later into NextJS Image component
		// src: image ? image + `?fm=avif&fit=fill&f=center` : ""
		src: image
		// 	? image + `?fm=avif&fit=fill&f=center`
		// 	: `https://placehold.co/${width}x${height}`,
	};

	




	//------------- Makeshift New Implementation (DELETE) ---------------


	// const mediaWidth = (!isSm) ? (mobileVideoWidth ? mobileVideoWidth : videoWidth) : videoWidth
	// const mediaHeight = (!isSm) ? (mobileVideoHeight ? mobileVideoHeight : videoHeight) : videoHeight 
	// const mediaWrapperWidth = (!isSm) ? (mobileVideoWrapperWidth ? mobileVideoWrapperWidth : videoWrapperWidth) : videoWrapperWidth 
	// const mediaWrapperHeight = (!isSm) ? (mobileVideoWrapperHeight ? mobileVideoWrapperHeight : videoWrapperHeight) : videoWrapperHeight 
	
	//------------- Makeshift New Implementation (DELETE) ---------------





	return (
		<>
			{/* <pre>{JSON.stringify(horizontalAlignment, null, 2)}</pre> */}
			<Card
			// Text:
			title={title}
			subtitle={subtitle}
			subtitleFontSize= {subtitleFontSize}
			titleFontSize= {titleFontSize}
			bodyFontSize= {bodyFontSize}
			description={description}
			hideText={hideText}
			centerTextVertically={centerTextVertically}
			// Button:
			hideButtons={hideButton}
			btn1_label={btn1_label}
			btn1_icon={btn1_icon}
			btn1_iconPosition={btn1_iconPosition}
			btn1_variant={btn1_variant}
			btn1_size={btn1_size}
			btn1_action={btn1_action}
			buttonUrl={buttonUrl}
			linkTargetBlank={linkTargetBlank}
			// Media:
			image={placeholderImage}
			styles={{
				"backgroundColor": cardBackgroundColor
			}}
			mediaPosition={videoPosition}
			video={video}
			mobileVideo={mobileVideo ? mobileVideo : video}



			// Old Implementation----------------------------
			mediaWidth={videoWidth}
			mediaHeight={videoHeight}
			mediaWrapperWidth={videoWrapperWidth}
			mediaWrapperHeight={videoWrapperHeight}


			//------------- Makeshift New Implementation (DELETE) ---------------
			// mediaWidth={mediaWidth}
			// mediaHeight={mediaHeight}
			// mediaWrapperWidth={mediaWrapperWidth}
			// mediaWrapperHeight={mediaWrapperHeight}
			// ------------- Makeshift New Implementation (DELETE) -------------



			mediaStartViewX={videoStartViewX}
			mediaStartViewY={videoStartViewY}
			// mediaBackgroundColor={}
			playButtonPosition={playButtonPosition}
			pauseable={pauseable || false}
			autoPlay={autoPlay}
			// Others
			className={classNames("overflow-hidden w-full", 
				{ 
					'rounded-video-card': roundedCorners,
				},
			)}
			animated={animated}
			animation={animationType}
			eventName={eventName}
			maxWidth={maxWidth}
			mediaOverlay={mediaOverlay}
			roundedCorners={roundedCorners}
			thumbnailOnly={thumbnailOnly}
			contentMinHeight={contentMinHeight}
			contentMaxHeight={contentMaxHeight}
			
			></Card>
		</>
	);
}
